import axiosApi from '../axios/axios-api';
import i18n from '../i18n';

export default async function checkPostalCode(token, postalCode) {
  const url = `checkPostalCode?cp=${encodeURIComponent(postalCode)}`;

  if (process.env.REACT_APP_URL_API) {
    try {
      const response = await axiosApi.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      });

      return {
        code: response?.data?.code || 500,
        data: response?.data?.data || null,
        message: response?.data?.message || '',
      };
    } catch (error) {
      return {
        code: error?.response?.data?.code || error?.response?.status || 500,
        data: null,
        message:
          error?.response?.data?.message || i18n.t('common.request-error'),
      };
    }
  }

  return {
    code: 500,
    data: null,
    message: i18n.t('common.request-error'),
  };
}
